import { gql } from '@apollo/client';

export * from './softwareEscrow.query.generated';

export const SOFTWARE_ESCROW = gql`
  query softwareEscrow($escrowId: ID!) {
    softwareEscrow(softwareEscrowId: $escrowId) {
      status
      activationNotification
      agreementSettingsConfigured
      id
      currentCompanyRole
      beneficiaryConfigured
      depositorConfigured
      startedBy
      beneficiaryActivityNotification
      depositorActivityNotification
      depositStatus
      beneficiaryDisruptionNotification
      beneficiaryDisruptionNotificationGracePeriod
      depositorDisruptionNotification
      depositorDisruptionNotificationGracePeriod
      storageRegion
      beneficiarySharedInformation
      escrowInvitation {
        ...EscrowInvitationFields
      }
      escrowTermination {
        ...EscrowTerminationFields
      }
      agreement {
        ...EscrowAgreementFields
      }
      beneficiary {
        ...BeneficiaryFields
      }
      depositor {
        ...DepositorFields
      }
      pendingActivation
      reportsEnabled
      reportsEnabledAt
      policy {
        ...EscrowPolicyFragment
      }
      adminReviewAt
      onboardingAt
      signedAt
      activatedAt
      createdAt
      assetVersionsLimit
      depositActivity
      certificationVerified
      certificationCertified
      requiredContentTypes
      lastDeposit
      userUpdatedAt
    }
  }
`;
